const getSelectedValueReactSelect = (options, label) => {
  return options.filter(option => option.label === label)
}

export default getSelectedValueReactSelect
